import { FC } from 'react';

import useBem from '@indicia/use-bem';

import BackgroundContainer from '../../../../shared/components/background-container/background-container';
import { SolutionsContainerType } from '../../types';
import ThemeZkHelpItem from './theme-zk-help-item';

import './theme-zk-help.scss';

type PropsType = SolutionsContainerType & {
  showProductsImmediately?: boolean;
};

const ThemeZkHelp: FC<PropsType> = ({ title, description, solutions, footerText, showProductsImmediately = false }) => {
  const { bemClassName, bemClassNames } = useBem('theme-zk-help');

  return (
    <BackgroundContainer type="beige">
      <div className={bemClassNames([bemClassName(), bemClassName(null, 'directly-visible', showProductsImmediately)])}>
        <div className={bemClassName('zk-help-header')}>
          <div className={bemClassName('zk-help-header-logo')}>
            <img
              src="/images/logos/zk.svg"
              alt="achmea"
            />
          </div>
          <div className={bemClassName('zk-help-header-content')}>
            <h3>{title}</h3>
            {description && <p>{description}</p>}
          </div>
        </div>
        <div className={bemClassName('zk-help-item-list')}>
          {solutions.map((solution) => {
            const { title: solutionTitle } = solution;

            return (
              <ThemeZkHelpItem
                key={solutionTitle}
                {...solution}
              />
            );
          })}
        </div>
        {showProductsImmediately && <div className={bemClassName('zk-help-footer')}>{footerText}</div>}
      </div>
    </BackgroundContainer>
  );
};

export default ThemeZkHelp;
